module.exports = __webpack_public_path__ + "img/GhostIsland_DG.98e65b36.png";